<template>
  <transition :duration="{ enter: 500, leave: 800 }">
    <b-modal
      id="qrcodeModal"
      ref="qrcodeModal"
      hide-footer
      hide-header
      modal-class="package-selection-modal"
      ignore-enforce-focus-selector=".webim-root"
      @hidden="hideModal"
    >
      <div class="popup__container">
        <span
          class="box_img"
          @click="$bvModal.hide('qrcodeModal')"
        >
          <img
            src="/packages/boxberry/theme/frontend/build/static/img/content/cancel.png"
            alt=""
            width="24"
            height="24"
          >
        </span>
        <div class="popup__content">
          <p>
            Отсканируйте QR-код для скачивания приложения
          </p>

          <span
            v-if="!loadImage"
            class="loader-overlay"
          >
            <span class="loader-img" />
          </span>
          <img
            class="popup__content__image"
            :src="qrCodeImageSrc"
            alt="QrCode"
            @load="loadImage = true"
          >
        </div>
      </div>
    </b-modal>
  </transition>
</template>

<script>

export default {
  name: 'MobileStoresQRCode',
  props: {
    qrCodeImageSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadImage: false,
    };
  },
  mounted() {
    this.$bvModal.show('qrcodeModal');
  },
  methods: {
    hideModal() {
      this.$emit('hide');
    },
    showModal() {
      this.$bvModal.show('qrcodeModal');
    },
  },
};
</script>


<style lang="scss" scoped>
  .modal-backdrop {
    background:  rgba(0, 0, 0, 0.5);
  }

  .popup__container {
    background: #FFFFFF;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.15);
    border-radius: 20px;
    position: relative;
    text-align: center;

    max-width: 502px;
    max-height: 578px;

    &:after {
      display: none;
    }

    p {
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      text-align: center;
      color: #333333;
      max-width: 350px;
      margin: 0 auto;
    }

    .box_img {
      position: absolute;
      top: 25px;
      right: 25px;
      opacity: .5;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }

    .popup__content {
      padding: 40px 20px 45px;
      overflow: hidden;

      &__image {
        width: 450px;
        height: 450px;
      }
    }
  }
  .popup__content__image {
    max-width: 80%;
  }
</style>

<style lang="scss">
  #qrcodeModal___BV_modal_backdrop_ {
    background:  rgba(0, 0, 0, 0.5);
  }
</style>
